export const defaultFeatureFlags = {
  'feature.multihost.show-network-warnings': false,
  'feature.multihost.show-higher-bitrates': false,
};

export type FeatureFlagType = keyof typeof defaultFeatureFlags;
